import { AppContextState } from "src/AppContextProvider";

/**
 * Gates the /spaces route.
 * Mirrors AdminNav's "spaces" tab visibility:
 * space:read on any space AND at least one space mutate ability.
 * Viewers (read-only with no space mutate abilities) are rejected,
 * closing pentest finding GRWBKK-1393 / PENTEST-138 / 3.3.1.
 */
export const canAccessSpacesRoute = (context: AppContextState): boolean => {
  const p = context.currentPermissions;
  return (
    p.validateAnySpace("space", "read") &&
    (p.validateAnySpace("space", "create") ||
      p.validateAnySpace("space", "update") ||
      p.validateAnySpace("space", "delete") ||
      p.validateAnySpace("space", "permissions"))
  );
};
